import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { LoanProgressData , dashboardApi } from "../home/dashboardService";
import { setLogout } from "features/authSlice";

export interface DashboardState {
  isDocumentUploadEnabled: boolean;
  loanProgress?: LoanProgressData;
  sessionHeldUnderReviewIds: string[];
}

const initialState: DashboardState = {
  isDocumentUploadEnabled: true,
  sessionHeldUnderReviewIds: [],
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    disableDocumentUpload: (state) => {
      return { ...state, isDocumentUploadEnabled: false };
    },
    enableDocumentUpload: (state) => {
      return { ...state, isDocumentUploadEnabled: true };
    },
    setLoanProgress: (state, action: PayloadAction<LoanProgressData>) => {
      state.loanProgress = action.payload;
    },
    addSessionHeldUnderReviewId: (state, action: PayloadAction<string>) => {
      if (!state.sessionHeldUnderReviewIds.includes(action.payload)) {
        state.sessionHeldUnderReviewIds.push(action.payload);
      }
    },
    removeSessionHeldUnderReviewId: (state, action: PayloadAction<string>) => {
      state.sessionHeldUnderReviewIds = state.sessionHeldUnderReviewIds.filter(
        (id) => id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setLogout, () => initialState)
      .addMatcher(dashboardApi.endpoints.getLoanStatus.matchFulfilled, (state, action) => {
        state.loanProgress = action.payload;
      })
      .addMatcher(dashboardApi.endpoints.getVestaMilestone.matchFulfilled, (state, action) => {
        state.loanProgress = action.payload;
      });
  },
});

export const { disableDocumentUpload, enableDocumentUpload, setLoanProgress, addSessionHeldUnderReviewId, removeSessionHeldUnderReviewId } = dashboardSlice.actions;

export const isDocumentUploadEnabled = (state: RootState): boolean => state.dashboard.isDocumentUploadEnabled;

export const getLoanProgress = (state: RootState): LoanProgressData | undefined => state.dashboard.loanProgress;

export const getSessionHeldUnderReviewIds = (state: RootState): string[] => state.dashboard.sessionHeldUnderReviewIds;

export default dashboardSlice.reducer;
